import { useState } from 'react';

export function useLocalStorage(key, initialValue = null) {
    const [value, setValue] = useState(() => {
        const stored = localStorage.getItem(key);
        return stored !== null ? stored : initialValue;
    });

    const set = (newValue) => {
        setValue(newValue);
        if (newValue !== null && newValue !== undefined) {
            localStorage.setItem(key, newValue);
        } else {
            localStorage.removeItem(key);
        }
    };

    return [value, set];
}
